export const encodeUrlString = (text) => {
  return encodeURI(String(text).replaceAll(".", "pv_vp"))
}
export const decodeUrlString = (text) => {
  return decodeURI(text).replaceAll("pv_vp", ".")
}